<template>
  <div class="lg:mt-0 md:mt-0 mt-8">
    <MedicalPopup
      :isActive="isDetailsActive"
      :selectedMedical="selectedMedical"
      @close="toggleDetails"
    />
    <div class="relative z-10">
      <!-- <div class="absolute bg-design-medc mob-hidden">
        <img
          src="../../../assets/images/bg-des/bgd6.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="bg-design-medc-dots absolute mob-hidden">
        <img
          src="../../../assets/images/caregiver/medc-dots.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="bg-design-mc-ecli absolute mob-hidden">
        <img
          src="../../../assets/images/caregiver/ecli.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div> -->
      <div class="w-full top-minus-8 mx-auto md:pb-0 lg:pb-0 pb-0 pt-0">
        <p
          class="title md-fsize25 md:pb-4 lg:pb-4 pb-2 sm-fsize16 md:font-normal lg:font-normal font-bold"
        >
          Medical Conditions
        </p>
        <span class="subtitle md-fsize18 sm-fsize13 bg-white">
          Home-based care could be long-term or short-term, depending on the
          condition and specific prognosis-based needs of the patient. This can
          prove challenging for a family caregiver who does not have the
          prerequisite skills or support for certain health conditions. We offer
          validated information, expertise, and support services to help you
          navigate through these hurdles to better enable the fulfilment of the
          role while taking care of your own well-being
        </span>
        <div
          class="grid md:grid-cols-2 lg:grid-cols-2 grid-cols-1 grid-rows-2 md:gap-10 lg:gap-10 gap-4 md:pt-10 lg:pt-10 pt-6"
        >
          <!-- @click="toggleDetails(true, item)" -->
          <div
            class="rounded-lg cursor-pointer relative h-400"
            @click="handleClickpage(item.text)"
            v-for="(item, index) in medicalcards"
            :key="index"
            :style="{ 'background-color': item.color }"
          >
            <img
              :src="item.img"
              class="w-full object-cover h-full flex filter-b5"
              alt="medical condition "
            />
            <div class="absolute bottom-0 left-0 pb-3 px-3">
              <p class="fsize24-16 text-white font-semibold">
                {{ item.text }}
              </p>
              <p class="pt-1 ellipsis-2 fsize18-14px text-white">
                {{ item.description }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MedicalPopup from "./MedicalPopup.vue";
export default {
  components: {
    MedicalPopup,
  },
  data() {
    return {
      selectedMedical: {},
      isDetailsActive: false,
      medicalcards: [
        {
          id: "01",
          text: "Dementia",
          description:
            "Dementia is a generic term for the impaired ability to remember, think, or make decisions. It can be of various kinds, with Alzheimer’s being the most common one. Family caregivers of people with dementia are important to the quality of the patient’s life. The effects of being a long-term caregiver often include psychological burden and social isolation. Our community, support groups, and counselling offer you the time and space to share your experiences and unburden your closed emotions.",
          img: "https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Caregiver-Page/Dementia.jpg",
          color: "#f1f1f199",
        },
        {
          id: "02",
          text: "Cancer",
          description:
            "A Cancer diagnosis causes complex feelings and lifestyle changes that can be overwhelming for families. The needs and requirements of caregiving for a cancer patient can vary depending on the type. It is emotionally and financially draining for the majority, especially when it involves palliative care. Our advisory services on financial planning, respite care, and home-based care offer you opportunities to create checks and balances for your long-term caregiving needs. ",
          img: "https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Caregiver-Page/Cancer.jpg",
          color: "#e3ceff66",
        },
        {
          id: "03",
          text: "Neurological Disorders",
          description:
            "Amyotrophic Lateral Sclerosis, or ALS, is a neurological disorder that progressively leads to the loss of voluntary muscle movements. Currently, there is no cure for ALS, and there is no effective treatment to halt or reverse the progression of the disease. Informal caregiving for a loved one with ALS can be physically and mentally stressful. Our educational resources and learning programmes can equip you with better knowledge and skills to provide effective caregiving. Simultaneously, our support services enable you to focus on your well-being.",
          img: "https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Caregiver-Page/ALS.jpg",
          color: "#f1f1f199",
        },
        {
          id: "04",
          text: "Palliative Care",
          description:
            "Palliative care is specialized medical care for people living with a serious illness, such as cancer or heart failure. Patients in palliative care may receive medical care for their symptoms, or palliative care, along with treatment intended to cure their serious illness. Palliative care is meant to enhance a person's current care by focusing on quality of life for them and their family. Here is a directory that will provide details and information for Palliative Care Centres. Here is a directory that will provide details for Palliative Care Centers",
          img: "https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/Caregiver-Page/Palliative-Care.jpg",
          hlink:
            "https://www.palliativecare.in/palliative-care-centers-chandigarh/",
          sayhere: "here.",
          color: "#e3ceff66",
        },
      ],
    };
  },
  methods: {
    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedMedical = item;
    },
    handleClickpage(name) {
      if (name.trim() == "Neurological Disorders") {
        this.$router.push({ name: "medical_neurologicaldisorders" });
      } else if (name === "Dementia") {
        this.$router.push({ name: "medical_dementia" });
      } else if (name === "Palliative Care") {
        this.$router.push({ name: "medical_palliative" });
      } else if (name === "Cancer") {
        this.$router.push({ name: "medical_cancer" });
      }
    },
    handleregister() {
      this.$router.push({ name: "register" });
    },
  },
};
</script>
<style>
@media (max-width: 640px) {
  .sm-h-1000px {
    height: 1000px !important;
  }
}
@media (min-width: 641px) {
  .top-minus-8 {
    top: -8rem;
  }
}
</style>
